import {FC} from 'react'
import {User} from '../../core/_models'

type Props = {
  user: User
}

const RolesCell: FC<Props> = ({user}) => (
  <span className='text-gray-800'>{user.roles?.map((role) => role.name).join(', ') || '-'}</span>
)

export {RolesCell}
